const AudiencesConfig = {
  collection: "audiences",
  fields: ["id", "name", "key"],

  filter: "filter[status][_eq]=active",

  adapter: class Audiences {
    constructor(audiences) {
      this.id = audiences.id;
      this.name = audiences.name;
      this.key = audiences.key;
    }
  }
};

export default AudiencesConfig;
